import axios from "axios";

export const backendUrl="https://api-mobily-ksa.kidsdal.com/";
//export const backendUrl="http://192.168.1.3:7013/";
export const baseUrl="https://kidsdal.com/";
// export const baseUrl="/";

export const getImagesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-images`);
    return response;
}

export const getVideosApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-videos`);
    return response;
}

export const sendOtp= async(msisdn)=>{
    const response= await axios.post(`${backendUrl}api/v1/sendopt`,{msisdn});
    return response;
}


export const OtpVerifyApi= async(otp,msisdn,ext_id)=>{
    const response= await axios.post(`${backendUrl}api/v1/verify-otp`,{otp, msisdn, ext_id});
    return response;
}


export const unsubscribeApi= async(payload)=>{
    const response= await axios.post(`${backendUrl}unsub-user`,payload);
    return response;
}
export const loginApi= async(msisdn)=>{
    const response= await axios.post(`${backendUrl}login`,{msisdn});
    return response;
}